module.exports = "../images/bear.png?v=f6425d8";